<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ResettleMemberSelectOption',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('left')">
      <div>姓名：{{ record?.userName }}</div>
      <div>身份证号：{{ record?.userIdCard }}</div>
    </div>
    <Tag v-if="record?.isAnZhi" color="gray"> 不予安置 </Tag>
    <template v-else>
      <Tag v-if="way" :color="RESETTLE_WAY_COLOR[way]"> 已{{ RESETTLE_WAY_LABEL[way] }} </Tag>
      <Tag v-else color="default">未安置</Tag>
    </template>
  </div>
</template>

<script lang="ts" setup name="ResettleMemberSelectOption">
import { computed } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { RESETTLE_WAY_LABEL, RESETTLE_WAY_COLOR, RESETTLE_WAY } from '@/constant/biz'
import { Tag } from '-/Common/Tag'
const [, bem] = createNamespace('ResettleMemberSelectOption')

const props = defineProps<{ record: ApiFamilyMembers.Item }>()

const way = computed(() => Object.values(RESETTLE_WAY).find(k => props.record?.[k] === 1))
</script>

<style lang="less">
.resettle-member-select-option {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__left {
    flex: 1;
  }
}
</style>
